(() => {
  'use strict';
  const root = document.querySelector('[data-sb-assistant]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const find = (name) => root.querySelector(`[data-sb-${name}]`);
  const launcher = find('open');
  const panel = find('panel');
  const input = find('input');
  const body = find('body');
  const messages = find('messages');
  const status = find('status');
  const error = find('error');
  const send = find('send');
  const retry = find('retry');
  const endpoint = 'https://gestionale.sbustiamo.it/api/public/assistant';
  const trustedHosts = new Set(['kexs0v-z3.myshopify.com', 'sbustiamo.it', 'www.sbustiamo.it']);
  let busy = false;
  let failedQuestion = '';
  // Only validated shopping preferences live in this page; never persist chat text.
  let conversationContext = null;
  const contextValues = {
    game: ['pokemon', 'onepiece', 'dragonball', 'lorcana', 'gundam'],
    language: ['it', 'en', 'ja', 'zh', 'fr', 'de', 'es', 'pt', 'nl', 'pl'],
    format: ['pack', 'box', 'deck', 'etb', 'tin', 'blister']
  };
  function validContext(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value) || Object.keys(value).sort().join(',') !== 'budgetEur,format,game,language,recommend') return null;
    for (const key of ['game', 'language', 'format']) if (value[key] !== null && !contextValues[key].includes(value[key])) return null;
    const budget = value.budgetEur;
    if (budget !== null && (typeof budget !== 'number' || !Number.isFinite(budget) || budget < 0 || budget > 100000 || Math.abs(budget * 100 - Math.round(budget * 100)) > 0.000001)) return null;
    if (typeof value.recommend !== 'boolean') return null;
    return { game: value.game, language: value.language, format: value.format, budgetEur: budget, recommend: value.recommend };
  }
  const newChat = document.createElement('button');
  newChat.type = 'button';
  newChat.textContent = 'Nuova chat';
  newChat.setAttribute('aria-label', 'Nuova chat: azzera conversazione e preferenze');
  root.querySelector('.sb-assistant__suggestions')?.append(newChat);
  input.placeholder = 'Scrivi la tua domanda…';
  const intro = root.querySelector('.sb-assistant__intro');
  if (intro) intro.textContent += ' Ricordo le preferenze finché questa pagina resta aperta.';

  function storeUrl(value) {
    try {
      const parsed = new URL(value);
      return parsed.protocol === 'https:' && trustedHosts.has(parsed.hostname) && !parsed.username && !parsed.password ? parsed.href : null;
    } catch (_) { return null; }
  }

  function revealLatest() { body.scrollTop = body.scrollHeight; }

  function message(speaker, text, response) {
    const entry = document.createElement('article');
    entry.className = `sb-assistant__message sb-assistant__message--${speaker}`;
    const label = document.createElement('span');
    label.className = 'sb-assistant__speaker';
    label.textContent = speaker === 'user' ? 'Tu' : 'Sbustiamo · AI';
    const content = document.createElement('p');
    content.className = 'sb-assistant__text';
    let displayText = text;
    if (response && Array.isArray(response.sources)) {
      const lastLine = text.trimEnd().split('\n').at(-1);
      if (response.sources.some((source) => source && source.url === lastLine && storeUrl(source.url))) {
        displayText = text.trimEnd().slice(0, -lastLine.length).trimEnd();
      }
    }
    content.textContent = displayText;
    entry.append(label, content);
    if (response && Array.isArray(response.sources)) {
      const links = document.createElement('div');
      links.className = 'sb-assistant__sources';
      const seen = new Set();
      response.sources.slice(0, 5).forEach((source) => {
        if (!source || typeof source.url !== 'string') return;
        const href = storeUrl(source.url);
        if (!href || seen.has(href)) return;
        seen.add(href);
        const link = document.createElement('a');
        link.href = href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = typeof source.title === 'string' ? source.title.slice(0, 160) : 'Consulta sul sito';
        links.append(link);
      });
      if (links.childElementCount) entry.append(links);
    }
    if (response && response.action === 'handoff') {
      const link = document.createElement('a');
      link.className = 'sb-assistant__handoff';
      link.href = 'https://wa.me/393454041616';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = 'Scrivici su WhatsApp ↗';
      entry.append(link);
    }
    messages.append(entry);
    while (messages.childElementCount > 20) messages.firstElementChild.remove();
    revealLatest();
  }

  function setBusy(value) {
    busy = value;
    send.disabled = value;
    retry.disabled = value;
    newChat.disabled = value;
    input.readOnly = value;
    panel.setAttribute('aria-busy', String(value));
    status.textContent = value ? 'Sto consultando catalogo e informazioni del negozio…' : '';
    revealLatest();
  }

  async function ask(question, isRetry = false) {
    if (busy || !question || question.length > 600) return;
    error.hidden = true;
    failedQuestion = '';
    if (!isRetry) message('user', question);
    setBusy(true);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 30000);
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        redirect: 'error',
        referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(conversationContext ? { question, context: conversationContext } : { question }),
        signal: controller.signal
      });
      if (!response.ok) {
        const failure = new Error('request_failed');
        failure.status = response.status;
        throw failure;
      }
      const payload = await response.json();
      if (!payload || !['answer', 'clarify', 'handoff'].includes(payload.action) || typeof payload.reply !== 'string' || !payload.reply.trim() || payload.reply.length > 12000) throw new Error('invalid_response');
      if (payload.context !== undefined) {
        const updatedContext = validContext(payload.context);
        if (!updatedContext) throw new Error('invalid_context');
        conversationContext = updatedContext;
      }
      message('assistant', payload.reply, payload);
      input.value = '';
    } catch (failure) {
      failedQuestion = question;
      find('error-text').textContent = failure.status === 429
        ? 'Il limite di richieste è stato raggiunto. Riprova più tardi oppure scrivici su WhatsApp.'
        : 'Non riesco a rispondere in questo momento. Puoi riprovare oppure contattarci su WhatsApp.';
      error.hidden = false;
    } finally {
      window.clearTimeout(timeout);
      setBusy(false);
      if (!panel.hidden) input.focus({ preventScroll: true });
    }
  }

  function open() {
    panel.hidden = false;
    launcher.hidden = true;
    launcher.setAttribute('aria-expanded', 'true');
    input.focus({ preventScroll: true });
  }
  function close() {
    panel.hidden = true;
    launcher.hidden = false;
    launcher.setAttribute('aria-expanded', 'false');
    launcher.focus({ preventScroll: true });
  }
  launcher.addEventListener('click', open);
  newChat.addEventListener('click', () => {
    if (busy) return;
    conversationContext = null;
    failedQuestion = '';
    while (messages.firstElementChild) messages.firstElementChild.remove();
    input.value = '';
    error.hidden = true;
    status.textContent = 'Nuova chat: le preferenze sono state azzerate.';
    input.focus({ preventScroll: true });
    revealLatest();
  });
  find('close').addEventListener('click', close);
  find('form').addEventListener('submit', (event) => {
    event.preventDefault();
    ask(input.value.trim());
  });
  retry.addEventListener('click', () => { if (failedQuestion) ask(failedQuestion, true); });
  root.querySelectorAll('[data-sb-question]').forEach((button) => button.addEventListener('click', () => {
    if (busy) return;
    input.value = button.dataset.sbQuestion;
    input.focus({ preventScroll: true });
  }));
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
      event.preventDefault();
      if (!busy) find('form').requestSubmit();
    }
  });
  panel.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const controls = Array.from(panel.querySelectorAll('button:not(:disabled), a[href], textarea:not(:disabled)')).filter((element) => element.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();

